var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDaysalart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFE8E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7_16848",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7_16848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 13.3333H20.6667V11.9999H11.3333V13.3333ZM11.3333 22.6666C10.9667 22.6666 10.6528 22.536 10.3917 22.2749C10.1306 22.0138 10 21.6999 10 21.3333V11.9999C10 11.6333 10.1306 11.3194 10.3917 11.0583C10.6528 10.7971 10.9667 10.6666 11.3333 10.6666H12V9.33325H13.3333V10.6666H18.6667V9.33325H20V10.6666H20.6667C21.0333 10.6666 21.3472 10.7971 21.6083 11.0583C21.8694 11.3194 22 11.6333 22 11.9999V15.7833C21.7889 15.6833 21.5722 15.5999 21.35 15.5333C21.1278 15.4666 20.9 15.4166 20.6667 15.3833V14.6666H11.3333V21.3333H15.5333C15.6111 21.5777 15.7028 21.811 15.8083 22.0333C15.9139 22.2555 16.0389 22.4666 16.1833 22.6666H11.3333ZM20 23.3333C19.0778 23.3333 18.2917 23.0083 17.6417 22.3583C16.9917 21.7083 16.6667 20.9221 16.6667 19.9999C16.6667 19.0777 16.9917 18.2916 17.6417 17.6416C18.2917 16.9916 19.0778 16.6666 20 16.6666C20.9222 16.6666 21.7083 16.9916 22.3583 17.6416C23.0083 18.2916 23.3333 19.0777 23.3333 19.9999C23.3333 20.9221 23.0083 21.7083 22.3583 22.3583C21.7083 23.0083 20.9222 23.3333 20 23.3333ZM21.1167 21.5833L21.5833 21.1166L20.3333 19.8666V17.9999H19.6667V20.1333L21.1167 21.5833Z",
    fill: "#F60000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaysalart);
export default __webpack_public_path__ + "static/media/daysalart.69c01f3207bb84754793ee684bfc0516.svg";
export { ForwardRef as ReactComponent };